import { Component, computed, effect, inject } from '@angular/core';
import { EventService } from '@services';
@Component({
  selector: 'blueTees-loader',
  template: `
  @if(isLoading()) {
    <div class="loading">Loading</div>
  }`,
  styleUrls: ['./loader.component.scss'],
  standalone: true
})
export class LoaderComponent {
  private event = inject(EventService);
  protected isLoading = computed(()=> this.event.isHttpRequest())

}
